const pako = require("pako");

let gzipToJson = (encoded) => {
  let binary = atob(encoded);
  let bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  // You appended the length at the start of gzBuffer, so you need to remove those bytes
  bytes = bytes.slice(4);

  // inflate the message & convert it to a string
  let inflated = pako.inflate(bytes);
  return JSON.parse(new TextDecoder().decode(inflated))[0];
}

let jsonToGzip = (obj) => {
  // Wrap in array if you expect an array-wrapped object like in gzipToJson
  const jsonStr = JSON.stringify([obj]);

  // Compress the string
  const compressed = pako.gzip(jsonStr);

  // Optional: prepend 4-byte length (to match gzipToJson slice(4) behavior)
  const length = compressed.length;
  const header = new Uint8Array(4);
  header[0] = (length >> 24) & 0xff;
  header[1] = (length >> 16) & 0xff;
  header[2] = (length >> 8) & 0xff;
  header[3] = length & 0xff;

  // Combine header and compressed data
  const fullBuffer = new Uint8Array(header.length + compressed.length);
  fullBuffer.set(header, 0);
  fullBuffer.set(compressed, 4);

  // Convert to base64
  const binaryStr = Array.from(fullBuffer)
    .map((b) => String.fromCharCode(b))
    .join('');
  return btoa(binaryStr);
}

export { gzipToJson, jsonToGzip};